import { productQuantityOrderedStyles } from "@insite/content-library/Components/ProductQuantityOrdered";
import { css } from "styled-components";

productQuantityOrderedStyles.cssOverrides = {
    formInputWrapper: css`
        input[type="number"]::-webkit-outer-spin-button,
        input[type="number"]::-webkit-inner-spin-button {
            opacity: 1;
        }
    `, // AMR-328 forced number inputs to always be visible
    inputSelect: css`
        /* ISC-11023 deal with this. */
        /* stylelint-disable-next-line */
        -moz-appearance: textfield;
    `,
};
